import { ContentSection } from '@vwfs-bronson/bronson-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ManageInsurancePolicies } from '../../components/manage-insurance-policies';
import { useContract } from '../../components/contracts/useContract';
import { withLoadingAndNoConnectionHandler } from '../../components/integration-wrapper';

const ManageInsurancePoliciesWithHandlers = withLoadingAndNoConnectionHandler(ManageInsurancePolicies);

export const ManageInsurancePoliciesPage: React.FC = () => {
    const { encryptedContractNumber } = useParams<{ encryptedContractNumber: string }>();
    const [loadingStarted, setLoadingStarted] = useState(false);

    const { data: contract, isLoading, loadingError } = useContract(encryptedContractNumber, {
        encryptedContractNumber: true,
    });

    const onLoading = useCallback(() => {
        if (isLoading) setLoadingStarted(true);
    }, [isLoading]);

    useEffect(() => {
        onLoading();
    }, [onLoading]);

    const isAllowed = contract?.hpAlert?.length;

    return (
        <ContentSection pageWrapSize="medium">
            <ManageInsurancePoliciesWithHandlers
                isLoading={isLoading}
                hasError={!!loadingError || (loadingStarted && !isLoading && !isAllowed)}
                encryptedContractNumber={encryptedContractNumber}
            />
        </ContentSection>
    );
};
